import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Table from '../../../components/Table/Table';
import TablePagination from '../../../components/TablePagination/TablePagination';
import DownloadMenu from '../../../components/DownloadMenu/DownloadMenu';
import ESimManagerTableFilters from './ESimManagerTableFilters';

import { Sort } from '../../../models/CommonModels';

import useESimManagerTable from './useESimManagerTable';
import usePortalConfig from '../../../hooks/usePortalConfig/usePortalConfig';

function ESimManagerTable() {
  const { configs } = usePortalConfig();
  const [t] = useTranslation();
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [sort, setSort] = useState<Sort>({ order: 'asc', orderBy: 'email' });
  const { headers, rows, totalUsers, isLoading, exportData } = useESimManagerTable(activePage, pageSize, query, sort);

  /**
   * On pagination change
   * Perform a new request
   * @param page
   * @param pSize
   */
  const handlePaginationChange = (page: number, pSize: number) => {
    setActivePage(page);
    setPageSize(pSize);
  };

  /**
   * On search click
   * @param val
   */
  const handleSearch = (val: string) => {
    setActivePage(1);
    setQuery(val);
  };

  /**
   * Handle change of the table sort
   * @param s
   */
  const handleOnSort = (s: Sort) => {
    setSort(s);
  };

  return (
    <Box paddingBottom="3rem">
      <ESimManagerTableFilters onSearch={handleSearch} isLoading={isLoading} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="body1" paddingBottom="1rem">
          {t('common.table.totalItems', { count: totalUsers })}
        </Typography>
        <DownloadMenu
          exportMaxNumberOfRows={configs.usersReport.exportMaxNumberOfRows}
          disabled={isLoading || totalUsers === 0}
          downloadCSV={() => exportData('csv')}
          downloadExcel={() => exportData('xlsx')}
          itemLength={totalUsers}
        />
      </Box>
      <Table headers={headers} rows={rows} isLoading={isLoading} defaultOrderBy={sort.orderBy} onSort={handleOnSort} />
      <TablePagination
        activePage={activePage}
        pageSize={pageSize}
        totalItems={totalUsers}
        handlePageChange={handlePaginationChange}
      />
    </Box>
  );
}

export default ESimManagerTable;
